export class Auth {
    email: string;
    password: string;
    token: string;

    constructor() {
        this.email = '';
    }
}
